import { render } from "./RoomView.vue?vue&type=template&id=5f2c67d1&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"

import "./RoomView.vue?vue&type=style&index=0&id=5f2c67d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2c67d1"]])

export default __exports__